import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import CustomLoader from '../common/CustomLoader';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ResponseDataMapping from '../external-api/ResponseDataMapping';
import { createUrl } from '../../common/utils/builder-url-util';
import WebHookHeaderNav from './WebHookHeaderNav';
import { validateName } from '../../common/utils/validate';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import Swal from 'sweetalert2';
import { REST_API } from 'drapcode-constant';
import showAlert from '../../common/utils/alert';
export class UpdateWebhook extends Component {
  static propTypes = {
    webhook: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    statusPath: '',
    selectedCollectionName: '',
    selectedMapping: {},
    itemsPath: '',
    customPrimaryKey: '',
    copied: false,
    toggleModal: false,
    name: '',
    nameError: '',
  };

  handleResponseDataChange = (name, value) => {
    this.setState({ [name]: value });
  };

  copyToClipboard = () => {
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  componentDidMount() {
    const { match, webhook, actions } = this.props;
    const { webhookId, projectId, version } = match.params;
    actions.loadWebhookDetails({ webhookId, projectId, version }).then(() => {
      const { webhookDetails } = webhook;
      if (webhookDetails) {
        const {
          name,
          statusPath,
          collectionName,
          customPrimaryKey,
          itemsPath,
          responseDataMapping,
        } = webhookDetails;
        this.setState({
          name,
          statusPath,
          selectedCollectionName: collectionName,
          customPrimaryKey,
          itemsPath,
          selectedMapping: responseDataMapping ? responseDataMapping : {},
        });
      }
    });
  }

  refreshMappingData = () => {
    const { webhookId, projectId, version } = this.props.match.params;
    this.props.actions.loadWebhookDetails({ webhookId, projectId, version });
  };

  sendUpdateRequest = () => {
    let { selectedMapping, selectedCollectionName, statusPath, itemsPath, customPrimaryKey } =
      this.state;
    const { webhookId, projectId, version } = this.props.match.params;
    const finalObject = {
      data: {
        responseDataMapping: selectedMapping,
        collectionName: selectedCollectionName,
        statusPath,
        itemsPath,
        customPrimaryKey,
      },
      webhookId,
      projectId,
      version,
    };
    this.props.actions.updateWebhook(finalObject).then(() => {
      this.props.history.push(`/webhook/${version}/v/${projectId}`);
    });
  };
  resetMapping = () => {
    this.setState({
      statusPath: '',
      selectedCollectionName: '',
      selectedMapping: {},
      itemsPath: '',
      customPrimaryKey: '',
      copied: false,
    });
  };
  handleDelete = (uuid) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      return actions.deleteWebhook({ uuid, projectId, version }).then(() => {
        history.replace(`/webhook/${version}/v/${projectId}`);
      });
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  handleChange = (event) => {
    const validateMsg = validateName(event.target.value);
    if (validateMsg) {
      return this.setState({ nameError: validateMsg });
    }
    this.setState({ name: event.target.value, nameError: '' });
  };

  handleSubmit = () => {
    const { webhookId, projectId, version } = this.props.match.params;
    const { name } = this.state;
    this.props.actions.updateWebhook({ data: { name }, webhookId, projectId, version }).then(() => {
      this.setState({ toggleModal: false });
    });
  };

  showWebhookRelatedContent = () => {
    const { webhookDetails } = this.props.webhook;
    const { projectDetail } = this.props.home;
    if (!webhookDetails) {
      return <div className="text-center">No Webhook Found</div>;
    }
    const { uuid } = webhookDetails;
    return (
      <div className="row">
        <div className="col-md-9 col-lg-9 col-sm-9 col-xs-12">
          <ul>
            <li>
              To refresh/reset Mapping, please send a POST request to <b>Sample Data URL</b>. Once
              you get success message then click on Reload Mapping button.
            </li>
            <li>
              To test webhook in preview, please send POST request to <b>Preview URL</b>
            </li>
            <li>
              To use webhook in publish, please send POST request to <b>Publish URL</b>
            </li>
            <li>Click on link to copy</li>
          </ul>
        </div>
        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-12">
          <div className="d-flex align-items-baseline justify-content-center">
            <UncontrolledDropdown group className="custom-pad-right-1 pr-2">
              <DropdownToggle color="theme-warning" title="Modify" className="btn-sm" caret>
                <i className="wb webconnect-cogs"></i> Modify
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => this.setState({ toggleModal: true })}
                  className="theme-green"
                >
                  <i className="wb webconnect-pencil"></i>&nbsp;Update Webhook Name
                </DropdownItem>
                <DropdownItem onClick={() => this.handleDelete(uuid)} className="theme-red">
                  <i className="wb webconnect-trash-regular"></i>&nbsp;Delete&nbsp;
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <button className="btn btn-theme-submit btn-sm" onClick={this.refreshMappingData}>
              <i className="wb webconnect-arrow-clockwise"></i> Reload Mapping
            </button>
          </div>
          {this.state.copied && <p className="text-center">Copied!</p>}
        </div>
        <div className="col-md-12 col-lg-12 col-sm-12">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>Sample Data</th>
                <td style={{ cursor: 'pointer' }}>
                  <CopyToClipboard
                    text={createUrl(projectDetail, uuid, 'mapping')}
                    onCopy={this.copyToClipboard}
                  >
                    <p id="webhookUrl">{createUrl(projectDetail, uuid, 'mapping')}</p>
                  </CopyToClipboard>
                </td>
              </tr>
              <tr>
                <th>Preview</th>
                <td style={{ cursor: 'pointer' }}>
                  <CopyToClipboard
                    text={createUrl(projectDetail, uuid, 'preview')}
                    onCopy={this.copyToClipboard}
                  >
                    <p id="webhookUrl">{createUrl(projectDetail, uuid, 'preview')}</p>
                  </CopyToClipboard>
                </td>
              </tr>
              <tr>
                <th>Production</th>
                <td style={{ cursor: 'pointer' }}>
                  <CopyToClipboard
                    text={createUrl(projectDetail, uuid, 'build')}
                    onCopy={this.copyToClipboard}
                  >
                    <p id="webhookUrl">{createUrl(projectDetail, uuid, 'build')}</p>
                  </CopyToClipboard>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ResponseDataMapping
          handleChange={this.handleResponseDataChange}
          statusPath={this.state.statusPath}
          itemsPath={this.state.itemsPath}
          selectedCollectionName={this.state.selectedCollectionName}
          selectedMapping={this.state.selectedMapping}
          customPrimaryKey={this.state.customPrimaryKey}
          sampleResponseData={webhookDetails.requestMappingData}
        />
        <div className="col-12 text-right">
          <button className="btn btn-default mr-2" onClick={this.resetMapping}>
            <i className="wb webconnect-eraser"></i>Reset
          </button>
          <button className="btn btn-theme-submit" onClick={this.sendUpdateRequest}>
            <i className="wb webconnect-save-regular"></i>Update
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { loadWebhookDetailsPending, webhookDetails } = this.props.webhook;
    const { projectId, version } = this.props.match.params;
    const { name, nameError } = this.state;
    return (
      <>
        {
          <Modal
            isOpen={this.state.toggleModal}
            toggle={() => this.setState({ toggleModal: !this.state.toggleModal })}
            backdrop="static"
          >
            <ModalHeader
              toggle={() => {
                this.setState({ toggleModal: !this.state.toggleModal });
              }}
              className="border-bottom"
            >
              <strong>Update Webhook</strong>
            </ModalHeader>
            <ModalBody>
              <div className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Method Name">
                          <span className="input-group-text">
                            <i className="wb webconnect-pencil"></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <input
                          type="text"
                          name="name"
                          value={name}
                          className="form-control form-control-sm"
                          placeholder="Name of Webhook"
                          onChange={this.handleChange}
                        />
                      </div>
                      {nameError && <p className="text-danger ml-5">{nameError}</p>}
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    <button
                      className="btn btn-theme-submit"
                      type="button"
                      onClick={this.handleSubmit}
                    >
                      <i className="wb webconnect-save-regular"></i>
                      &nbsp;Update Webhook&nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        }
        <div className="main">
          <div className="section">
            <WebHookHeaderNav
              version={version}
              activeTab={REST_API}
              projectId={projectId}
              title="Webhook"
              icon="webhook"
            />
            <div className="container">
              <div className="row mx-auto">
                <ParentContentCard
                  title={`Update Webhook: ${webhookDetails && webhookDetails.name}`}
                  icon="webhook"
                >
                  {loadWebhookDetailsPending ? (
                    <div className="text-center">
                      <CustomLoader
                        loading={loadWebhookDetailsPending}
                        size="20px"
                        color="#303453"
                      />
                    </div>
                  ) : (
                    this.showWebhookRelatedContent()
                  )}
                </ParentContentCard>
                <ParentDocCard>
                  <h5>
                    <b>Webhook </b>
                  </h5>
                  <p>
                    Webhooks allows you to send your data on DrapCode’s API and then save it to your
                    web app’s database on DrapCode after collection mapping. You can create a
                    webhook using REST API.
                  </p>
                  <br />
                </ParentDocCard>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    webhook: state.webhook,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateWebhook);
